import { Dispatch, SetStateAction } from 'react';
import './style.scss';
import { icons } from 'constants/icons';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { BankButton, BankInput, BankButtonProps } from '../module';
import { useSearchBank, useSearchBranch } from './hooks';
import { BankStepProps } from '../hooks';
import { FormError } from 'views/mutual/formErrorScroll';

type SearchBankProps = {
  setBankList: Dispatch<SetStateAction<string[]>>;
} & BankButtonProps &
  BankStepProps;

export const SearchBank = (props: SearchBankProps) => {
  const searchBankProps = useSearchBank(props.modalStep, props.setModalStep, props.setBankList);
  return (
    <form onSubmit={searchBankProps.formik.handleSubmit} className="searchBank">
      <SearchTemplete {...props} {...searchBankProps} />
      <BankButton {...props} {...searchBankProps} />
    </form>
  );
};

type SearchBranchProps = {
  bankName: string;
  setBranchList: Dispatch<SetStateAction<string[]>>;
} & BankButtonProps &
  BankStepProps;

export const SearchBranch = (props: SearchBranchProps) => {
  const searchBranchProps = useSearchBranch(props.bankName, props.modalStep, props.setModalStep, props.setBranchList);
  return (
    <form onSubmit={searchBranchProps.formik.handleSubmit} className="searchBank">
      <SearchTemplete {...props} {...searchBranchProps} />
      <BankButton {...props} {...searchBranchProps} />
    </form>
  );
};

const KATAKANA_LIST = [
  ['ア', 'カ', 'サ', 'タ', 'ナ', 'ハ', 'マ', 'ヤ', 'ラ', 'ワ'],
  ['イ', 'キ', 'シ', 'チ', 'ニ', 'ヒ', 'ミ', '', 'リ', ''],
  ['ウ', 'ク', 'ス', 'ツ', 'ヌ', 'フ', 'ム', 'ユ', 'ル', ''],
  ['エ', 'ケ', 'セ', 'テ', 'ネ', 'ヘ', 'メ', '', 'レ', ''],
  ['オ', 'コ', 'ソ', 'ト', 'ノ', 'ホ', 'モ', 'ヨ', 'ロ', 'ヲ'],
];

type searchTempleteProps = {
  selectedKanaProps: {
    value: string;
    onChange: (value: string) => void;
    error: string | undefined;
    title: string;
  };
  inputKanaProps: {
    inputTemplete: {
      value: string;
      type: string;
      onChange: (value: string) => void;
      error: string | undefined;
    };
    onSearch?: () => void;
    title: string;
    comment?: string;
    example: string;
  };
  inputCodeProps: {
    inputTemplete: {
      value: string;
      type: string;
      onChange: (value: string) => void;
      error: string | undefined;
    };
    onSearch?: () => void;
    title: string;
    comment?: string;
    example: string;
  };
  linkLabel?: string;
};

export const SearchTemplete = (props: searchTempleteProps & BankButtonProps) => {
  return (
    <div className="searchTemplete wrapper">
      <div className="searchTemplete baseLayout">
        <div className={`searchTemplete kanaIndex`}>
          {props.selectedKanaProps.title}
          <div className="searchTemplete chart">
            {KATAKANA_LIST.map((column) => (
              <div className="searchTemplete chart_row">
                {column.map((kana) => (
                  <KanaCell kana={kana} {...props.selectedKanaProps} />
                ))}
              </div>
            ))}
          </div>
          <FormError className="inputTemplate_error" error={props.selectedKanaProps.error} />
        </div>
        <div className="searchTemplete column">
          <BankInput {...props.inputKanaProps} />
          <BankInput {...props.inputCodeProps} />
        </div>
      </div>
      {props.linkLabel && (
        <div className="searchTemplete link">
          <SvgIcon icon={icons.yucho} size={IconSize.icon_xs} />
          {'ゆうちょ銀行への振込について'}
        </div>
      )}
    </div>
  );
};

type KanaCellProps = {
  kana: string;
  onChange: (value: string) => void;
};
const KanaCell = (props: KanaCellProps) => {
  const { kana, onChange } = props;
  return (
    <div className="searchTemplete chart_cell" onClick={kana ? () => onChange(kana) : undefined}>
      {kana}
    </div>
  );
};
